import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { TermsAndConditions } from './components/pages/TermsAndConditions';
import { PrivacyPolicy } from './components/pages/PrivacyPolicy';
import { Contact } from './components/pages/Contact';
import { MetaPixel } from './components/MetaPixel';
export function AppRouter() {
  return <BrowserRouter data-id="element-9">
      <MetaPixel data-id="element-10">
        <Routes data-id="element-11">
          <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
          <Route path="/terminos-y-condiciones" element={<TermsAndConditions data-id="element-15" />} data-id="element-14" />
          <Route path="/politica-de-privacidad" element={<PrivacyPolicy data-id="element-17" />} data-id="element-16" />
          <Route path="/contacto" element={<Contact data-id="element-19" />} data-id="element-18" />
        </Routes>
      </MetaPixel>
    </BrowserRouter>;
}